import styled from 'styled-components';
import { LegendMixin } from '../../mixins/components/LegendMixin';
import { Label } from '../Label/Label';

/**
 * An HTML [legend element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend).
 *
 * `Legend` extends the `Label` component and is used
 * to caption a group of controls within a `FieldSet`.
 *
 * @extends Label
 * @since 8.0.0
 */
var Legend = /*#__PURE__*/styled(Label).attrs({
  forwardedAs: 'legend'
}).withConfig({
  displayName: "Legend",
  componentId: "c11n-8-107-0__sc-1fo3js-0"
})(["", ""], LegendMixin);
Legend.displayName = 'Legend';

/** @component */
export { Legend };